export const URL = {
  FAILSAFE_TIMEOUT: 'https://knowledge-base.yieldbird.com/yieldbird-platform/failsafe-timeout',
  PRICE_GENIUS_ALWAYS_ON:
    'https://www.notion.so/ybknowledgebase/Automatic-Price-Genius-on-off-9d291b70a41e46b0bcce2fd15ff532b2',
} as const
